import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as sessionActionCreators from '../../actions/session';
import { fetchTerritories } from '../../actions/territories';
import { fetchCoordinations } from '../../actions/coordinations';
import { fetchUsers } from '../../actions/users';


import {routerActions} from 'react-router-redux';
import LoginForm from '../presentation/LoginForm';

function mapStateToProps(state) {
    return {
        session : state.session
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({...sessionActionCreators, ...routerActions, fetchTerritories, fetchCoordinations, fetchUsers}, dispatch);
}

class Login extends React.Component {
    
    componentWillReceiveProps(props) {
        const user = props.session.user;
        if(user) {
            this.props.push('/');
            this.props.fetchTerritories();
            this.props.fetchCoordinations();
            this.props.fetchUsers();
        }
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-6 offset-md-3">
                        <LoginForm login={this.props.postLogin} session={this.props.session}/>            
                    </div>
                </div>
            </div>
        );
    }
}

const LoginContainer = connect(mapStateToProps, mapDispatchToProps)(Login);
export default LoginContainer;


/** WEBPACK FOOTER **
 ** ./src/components/containers/Login.jsx
 **/